module.exports = __webpack_public_path__ + "img/140006.1e099656.png";